import LayoutCheckbox from 'components/forms/layoutCheckbox';
import LayoutInput from 'components/forms/layoutInput';
import LayoutSelect from 'components/forms/layoutSelect';
import LoadingBtn from 'components/loadingBtn';
import PropTypes from 'prop-types';
import React from 'react';
import ToggleSelect from 'components/forms/ToggleSelect';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {balanceColumns} from 'helpers/fieldHelpers';
import {chemicalBaseTypes, countries, systemTypes} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';


class WaterProblems extends React.Component {
  static propTypes = {
    analysis: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
    dataChanged: PropTypes.func.isRequired,
    edit: PropTypes.bool.isRequired,
    isType: PropTypes.func.isRequired,
    pool: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    saveAnalysis: PropTypes.func.isRequired,
    isScanning: PropTypes.bool.isRequired,
    isValidating: PropTypes.bool.isRequired,
    updateFocusElement: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };

  getAlgae = () => {
    let {dealer, analysis} = this.props;
    let algaeProducts = this.getAlgaeProducts();
    let all = [];
    let {formatMessage} = this.props.intl;

    if (this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa) {
      all.push(<LayoutCheckbox label={formatMessage({id: 'preferences.swampy'})}
                               dataKey='swampy'
                               key='swampy'
                               value={analysis.swampy}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<LayoutCheckbox label={formatMessage({id: 'general.green.algae'})}
                               dataKey='greenAlgae'
                               key='greenAlgae'
                               value={analysis.greenAlgae}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<LayoutCheckbox label={formatMessage({id: 'general.mustard.algae'})}
                               dataKey='mustardAlgae'
                               key='mustardAlgae'
                               value={analysis.mustardAlgae}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<LayoutCheckbox label={formatMessage({id: 'scan.slime.mold'})}
                               dataKey='slimeMold'
                               key='slimeMold'
                               value={analysis.slimeMold}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<ToggleSelect label={formatMessage({id: 'general.black.algae'})}
                             dataKey='blackAlgae'
                             key='blackAlgae'
                             value={analysis.blackAlgae}
                             onChange={this.props.dataChanged}
                             options={[formatMessage({id: 'general.light'}), formatMessage({id: 'general.extensive'})]}
                             keys={['1', '2']}/>);

      if(dealer.country !== 'CA') {
        all.push(<LayoutSelect label={formatMessage({id: 'general.algae.product'})}
                               dataKey='algaeProduct'
                               key='algaeProduct'
                               value={analysis.algaeProduct}
                               dataChanged={this.props.dataChanged}
                               condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                               editMode={this.props.edit}
                               options={algaeProducts.options}
                               keys={algaeProducts.keys}/>);
      }
    } else {
      all.push(<LayoutCheckbox label={formatMessage({id: 'general.algae'})}
                               dataKey='spaAlgae'
                               key='spaAlgae'
                               value={analysis.spaAlgae}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);
    }

    return balanceColumns(all, 3);
  };

  getAlgaeProducts = () => {
    let algaeProducts = {'options': ['Banish', 'Backup 2', 'Spot Kill'], keys: ['40', '39', '101']};

    if (this.props.pool.typeID !== systemTypes.spa) {
      algaeProducts.options.unshift('Algae Complete');
      algaeProducts.keys.unshift('28');
    }

    if (this.props.isType([chemicalBaseTypes.saltWaterPool]) && this.props.dealer.saltScapes) {
      algaeProducts.options.push('SaltScapes Algae Remover');
      algaeProducts.keys.push('78');
    }
    return algaeProducts;
  };

  getCDSection = () => {
    const dealer = this.props.dealer;
    let analysis = this.props.analysis;
    let all = [];
    let {formatMessage} = this.props.intl;

    let cdProducts = this.props.pool.typeID === systemTypes.spa ? ['Chlorinating Concentrate'] :
      ['BurnOut 73', 'BurnOut 3', 'BurnOut 35', 'Chlorinating Liquid', 'ProGuard', 'Print All'];
    let cdCodes = this.props.pool.typeID === systemTypes.spa ? ['12200'] : ['1173', '1175', '1100', '1250', '88888', '77777'];

    all.push(<LayoutInput label={formatMessage({id: 'scan.dist.standard'})}
                          dataKey='cDDistStandard'
                          key='cDDistStandard'
                          value={analysis.cDDistStandard}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                          group={this.props.group}
                          validate={val => analysis.chlorineDemandOnly ? !!val && val !== 0 && val >= 0 && val <= 999 : !val || val >= 0 && val <= 999}
                          validateMessage={<FormattedMessage id='scan.validate.dist.standard'/>}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.sample'})}
                          dataKey='cDSample'
                          key='cDSample'
                          value={analysis.cDSample}
                          group={this.props.group}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                          validate={
                            val => analysis.chlorineDemandOnly ?
                              !!val && val !== 0 && val >= 0 && val <= 999 &&
                              parseFloat(val || 0) <= parseFloat(analysis.cDDistStandard || 0) :
                              !val || val >= 0 && val <= 999 && parseFloat(val || 0) <= parseFloat(analysis.cDDistStandard || 0)
                          }
                          validateMessage={<FormattedMessage id='scan.validate.sample'/>}/>);

    if (dealer.country === countries.US) {
      all.push(<LayoutSelect label={formatMessage({id: 'general.product'})}
                             dataKey='cDProduct'
                             key='cDProduct'
                             value={analysis.cDProduct}
                             dataChanged={this.props.dataChanged}
                             condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                             editMode={this.props.edit}
                             options={cdProducts}
                             keys={cdCodes}/>);
    }


    let setFocusTo = '';
    let numInvalid = 0;

    for (let i = 0; i < all.length; ++i) {
      if (all[i].props.validate && (all[i].props.condition || all[i].props.condition === undefined)) {
        let valid = all[i].props.validate(all[i].props.value);

        if (!valid) {
          if (!setFocusTo) {
            setFocusTo = all[i].props.dataKey;
          }
          numInvalid += 1;
        }
      }
    }

    return [balanceColumns(all, 3), setFocusTo];
  };

  getChlorineDemand = () => {
    let analysis = this.props.analysis;
    let all = [];
    let {formatMessage} = this.props.intl;

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.chlorine.demand.only'})}
                             dataKey='chlorineDemandOnly'
                             key='chlorineDemandOnly'
                             value={analysis.chlorineDemandOnly}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}/>);

    return balanceColumns(all, 3);
  };

  getClarifierDemand = () => {
    let analysis = this.props.analysis;
    let all = [];
    let {formatMessage} = this.props.intl;

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.clarifier.demand'})}
                             dataKey='clarifierDemand'
                             key='clarifierDemand'
                             value={analysis.clarifierDemand}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}/>);

    return balanceColumns(all, 3);
  };

  getSurfaceProblems = () => {
    let analysis = this.props.analysis;
    let all = [];
    let isPool = this.props.pool.typeID === systemTypes.pool;
    let isSpa = this.props.pool.typeID === systemTypes.spa;
    let isSwimSpa = this.props.pool.typeID === systemTypes.swimspa;
    let {formatMessage} = this.props.intl;

    all.push(<ToggleSelect label={formatMessage({id: 'scan.copper.staining'})}
                           dataKey='copperStaining'
                           key='copperStaining'
                           value={analysis.copperStaining}
                           onChange={this.props.dataChanged}
                           options={[formatMessage({id: 'general.mild'}), formatMessage({id: 'general.severe'})]}
                           keys={['1', '2']}
                           condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.iron.staining'})}
                             dataKey='ironStaining'
                             key='ironStaining'
                             value={analysis.ironStaining}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.unknown.staining'})}
                             dataKey='unknownStaining'
                             key='unknownStaining'
                             value={analysis.unknownStaining}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.scale.buildup'})}
                             dataKey='scaleBuildup'
                             key='scaleBuildup'
                             value={analysis.scaleBuildup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.waterline.buildup'})}
                             dataKey='waterBuildup'
                             key='waterBuildup'
                             value={analysis.waterBuildup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isSpa || isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.organic.staining'})}
                             dataKey='organicStaining'
                             key='organicStaining'
                             value={analysis.organicStaining}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={(isPool || isSwimSpa) && this.props.dealer.country === countries.US}/>);


    return balanceColumns(all, 3);
  };

  getWaterClarity = () => {
    let analysis = this.props.analysis;
    let all = [];
    let {formatMessage} = this.props.intl;

    all.push(<LayoutCheckbox label={formatMessage({id: this.props.pool.typeID === systemTypes.spa ?
        'detailed-report.problems.cloudy' :
        'analysis.cloudy.cant.botttom'})}
                             dataKey='cloudy'
                             key='cloudy'
                             value={analysis.cloudy}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'general.hazy'})}
                             dataKey='hazy'
                             key='hazy'
                             value={analysis.hazy}
                             dataChanged={this.props.dataChanged}
                             condition={this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa}
                             editMode={this.props.edit}/>);

    if (analysis.hazy) {
      all.push(<LayoutSelect label={formatMessage({id: 'general.hazy.product'})}
                             dataKey='clarifier'
                             key='clarifier'
                             value={analysis.clarifier}
                             dataChanged={this.props.dataChanged}
                             condition={this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa}
                             editMode={this.props.edit}
                             options={['Natural Clarifier', 'Polysheen Blue']}
                             keys={[60, 62]}/>);
    }

    all.push(<LayoutCheckbox label={formatMessage({id: 'preferences.foaming'})}
                             dataKey='foaming'
                             key='foaming'
                             value={analysis.foaming}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([3, 5, 6, 8, 13, 15])}/>);

    return balanceColumns(all, 3);
  };

  render() {
    let waterClarity = this.props.pool ? this.getWaterClarity() : [];
    let algae = this.props.pool ? this.getAlgae() : [];
    let surfaceProblems = this.props.pool ? this.getSurfaceProblems() : [];
    let chlorineDemand = this.props.pool ? this.getChlorineDemand() : [];
    let clarifierDemand = this.props.pool ? this.getClarifierDemand() : [];
    let [CDSection, focusElement] = this.props.pool ? this.getCDSection() : [];
    let {formatMessage} = this.props.intl;

    this.props.updateFocusElement(focusElement, false);

    return (
      <div className='row'>
        <div className='col-xs-12'>
          <h2>
            <FormattedMessage id="general.water.problems"/>
            <ToolTip title={formatMessage({id: 'scan.completing.section.improves'})}
                     position={tooltipPositions.topRight}
                     iconOnly/>
          </h2>
          <div className='analysis-body'>
            <div className='row'>
              <div className='col-xs-12'>
                <p style={{marginBottom: 15}}><FormattedMessage id="scan.customer.water.look"/></p>
              </div>
            </div>
            <div>
              <label className='shiftRight'><FormattedMessage id="general.water.clarity"/></label>
              {waterClarity}
            </div>
            <hr/>
            <div>
              <label className='shiftRight'><FormattedMessage id="general.algae"/></label>
              {algae}
            </div>
            <hr/>
            <div>
              <label className='shiftRight'><FormattedMessage id="general.surface.problems"/></label>
              {surfaceProblems}
            </div>
            {this.props.isType([1, 2, 5, 6, 7, 12, 13, 14, 15]) ? <div>
              <hr/>
              <div>
                <label className='shiftRight'><FormattedMessage id="preferences.chlorine.demand"/></label>
                {chlorineDemand}
                {CDSection}
              </div>
            </div> : null}
            {this.props.isType([chemicalBaseTypes.softswimPool]) ? <div>
              <hr/>
              {clarifierDemand}
            </div> : null}
          </div>

        </div>
      </div>
    );
  }
}

export default injectIntl(WaterProblems);
